import { HarvestTypes } from "@gtpl/shared-models/common-models";
import { CompanyCategoryEnum } from "@gtpl/shared-models/raw-material-procurement";
import { ApiProperty } from "@nestjs/swagger";
import { IsAlphanumeric, IsNotEmpty, IsOptional, Matches, MaxLength } from "class-validator";

export class RmCountPriceListDTO{
    @ApiProperty()
    @IsNotEmpty({message:"rm count price list id should not be empty"})
    @IsAlphanumeric()
    rmratesId :number;


    // @ApiProperty()
    // @IsNotEmpty({message:"count range should not be empty"})
    // @IsAlphanumeric()
    // @IsOptional()
    // minValue:number;

    // @ApiProperty()
    // @IsNotEmpty({message:"count range should not be empty"})
    // @IsAlphanumeric()
    // @IsOptional()
    // maxValue:number;

    @ApiProperty()
    @IsNotEmpty({message:"count should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    count:number;

    @ApiProperty()
    @IsNotEmpty({message:"price should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    price:number;

    // @ApiProperty()
    // @IsNotEmpty({message:"min price should not be empty"})
    // @IsAlphanumeric()
    // @IsOptional()
    // minPrice:number;
    
    // @ApiProperty()
    // @IsNotEmpty({message:"mid price should not be empty"})
    // @IsAlphanumeric()
    // @IsOptional()
    // midPrice:number;
    
    // @ApiProperty()
    // @IsNotEmpty({message:"high price should not be empty"})
    // @IsAlphanumeric()
    // @IsOptional()
    // highPrice:number;

    @ApiProperty()
    isActive:boolean;

    @ApiProperty()
    @IsOptional()
    @MaxLength(50,{message:"Created User allows maximum 50 characters"}) 
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })  
     createdUser: string | null;


    createdAt:Date;

  
    updatedAt: Date;

    effectiveFromDate:Date

    effectiveToDate:Date

    @ApiProperty()
  @IsOptional()
  @MaxLength(50, { message: "Updated User allows maximum 50 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
    updatedUser: string | null;

  
    @ApiProperty()
    versionFlag : number;
  
    @ApiProperty()
    @IsAlphanumeric()
    @IsOptional()
    company:string;

    @ApiProperty()
    type : HarvestTypes;
    @ApiProperty()
    category : CompanyCategoryEnum;
}